import React, { Component } from 'react';
import PropTypes from "prop-types";

import { withTranslation } from 'react-i18next';

class WebNetComments extends Component {
     

    state = { 

        id: "",
        notes: "",
        loading: true,
        disableDiv: false,
    };



    async componentDidMount() { 
        const { id } = this.props;
        if (id) {
            this.fetchPatientsNotes(id);
            this.setState({ id: id, loading: false });
        }
    }

    /*
     * Fetch ---selected Patient--- Comments
     */
    fetchPatientsNotes = async (id) => {
        const { apiCall, t } = this.props;
        let aTemp = [];
        if (id) {
            const result = await apiCall("get", "/patients/notes/" + id, {});
            aTemp = result.data;
            let note = ""; // t( "(no comments)") ;
            if (aTemp.length > 0) note = aTemp[0].note; 
            this.setState({ notes: note, disableDiv: true });
        } else {
            this.setState({ disableDiv: false });
        }
    }

  static renderComments(notes) {
    return (
        <p>
            {notes}
        </p>
    );
  }

  render() {


      var divStyle = {
          display: this.state.disableDiv ? 'block' : 'none'
      };

      let contents = this.state.loading && this.state.id !== ""
      ? <p><em>t("Loading...")</em></p>
        : WebNetComments.renderComments(this.state.notes);
    return (
        <div style={divStyle}>
        {contents}
      </div>
    );
  }
}

export default withTranslation()(WebNetComments);

WebNetComments.propTypes = {
    id: PropTypes.string,
    apiCall: PropTypes.func.isRequired,
}